module.exports = __webpack_public_path__ + "19fa95b2b9c3e1b537fa7bda9fd4c618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navbar_2.png
// module id = 104
// module chunks = 30